import React from "react";
import { Radio } from "antd";
import { useHistory } from "react-router-dom";

function TabMenu(props) {
  let history = useHistory();

  const handleMenuChange = (e) => {
    history.push(`/account/${e.target.value}`);
  };

  return (
    <div>
      <Radio.Group
        value={props.menu}
        onChange={handleMenuChange}
        style={{ marginBottom: 10 }}
      >
        <Radio.Button value="profile" style={{ marginRight: 5 }}>
          Profile
        </Radio.Button>
        <Radio.Button value="change-password" style={{ marginRight: 5 }}>
          Change Password
        </Radio.Button>
      </Radio.Group>
    </div>
  );
}

export default TabMenu;
